import { combineReducers } from 'redux';

import errorReducer from 'modules/global/reducers/generic.error';
import loadingReducer from 'modules/global/reducers/generic.loading';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import {
  CLOSE_CREATE_INTERVENTION_MODAL,
  INTERVENTIONS_FETCH,
  CREATE_INTERVENTION_REQUEST,
  OPEN_CREATE_INTERVENTION_MODAL,
  CREATE_INTERVENTION_SUCCESS
} from 'modules/interventions/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import approveManually from './approveManually';
import createReminder from './createReminder';
import duplicate from './duplicate';
import editedTire from './editedTire';
import imports from './imports';
import isChecklistGroupVisible from './isChecklistGroupVisible';
import resendModal from './isResendOpen';
import send from './send';
import uniqueVideo from './uniqueVideo';
import workOrder from './workOrder';

/**
 * @typedef {{
 *  send: import('./send').SendState,
 *  imports: import('./imports').ImportsState,
 *  workOrder: import('./workOrder').WorkOrderState,
 *  approveManually: import('./approveManually').ApproveManuallyState,
 *  reminders: import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer,
 *  editedTire: string,
 *  resendModal: boolean,
 *  checklistGroupTarget: {
 *    visible: boolean,
 *  },
 *  create: {
 *    isLoading: boolean,
 *    isVisible: boolean,
 *    apiError: any
 *  },
 *  createReminder: {
 *    isLoading: boolean,
 *    apiError: any
 *  },
 *  duplicate: import('./duplicate').DuplicateModalState,
 *  uniqueVideo: {
 *    isVisible: boolean,
 *    isLoading: boolean,
 *    apiError: any
 *  }
 * }} ModalsState
 */

export default combineReducers({
  send,
  imports,
  duplicate,
  workOrder,
  uniqueVideo,
  approveManually,
  createReminder,
  create: combineReducers({
    isLoading: loadingReducer(CREATE_INTERVENTION_REQUEST),
    apiError: errorReducer(CREATE_INTERVENTION_REQUEST),
    isVisible: createReducer(false, {
      [LOCATION_CHANGE]: () => false,
      [OPEN_CREATE_INTERVENTION_MODAL]: () => true,
      [CLOSE_CREATE_INTERVENTION_MODAL]: () => false,
      [CREATE_INTERVENTION_SUCCESS]: () => false,
    })
  }),
  reminders: createSearchReducers(INTERVENTIONS_FETCH, {
    global: { matcher: ({ meta }) => meta?.source === 'create-reminders' },
    // Specific cases
    hasMore: { [CLOSE_CREATE_INTERVENTION_MODAL]: () => false },
    ids: {
      [CLOSE_CREATE_INTERVENTION_MODAL]: () => [],
    },
  }),
  editedTire,
  resendModal,
  checklistGroupTarget: combineReducers({
    visible: isChecklistGroupVisible,
  }),
});
